.root {
  // Scoped under `.root` to win over the MUI badge's own dot size and color.
  & .dot {
    height: 14px;
    min-width: 14px;
    border: 2px solid var(--color-neutral-silver);
    border-radius: 7px;
    color: var(--color-primary-active);
  }
}
